import React from 'react';
import { bool, string } from 'prop-types';

import { Box, Center, Text, Link, Heading, Divider } from '@chakra-ui/react';

import WithAnimation from '@components/Common/WithAnimation';
import Image from '@components/Common/LazyImage';
import Wave from '@components/Common/Wave/V2';
import useSPH from '@hooks/useSPH';

import Invitato from '@/images/invitato.png';

import { THE_BRIDE, SOUND_BY, SOUND_URL, URL_IG_INVITATO } from '@/constants';
import { LOGO_VENDOR_DALANG } from '@/constants/assets';
import { ENABLE_COLLABORATION } from '@/constants/feature-flags';
import { SPH_LOGO_BLACK } from '@/constants/sph';

function CopyRightSection() {
  const sph = useSPH();

  return (
    <Box>
      <Box bgColor="bgPrimary" marginTop="-2px" padding="32px">
        <WithAnimation>
          <Text align="center" color="mainColorDarkText" padding="8px 0">
            We can’t wait to meet your family and see everyone gathered as part of the SPH family.
            See you at New Family Orientation day!
          </Text>
        </WithAnimation>
        <WithAnimation>
          <Center>
            <Image src={sph.imgFooter} maxWidth="90%" borderRadius="16px" margin="32px 0" />
          </Center>
        </WithAnimation>
        <Heading color="mainColorDarkText" textAlign="center" fontWeight="normal" fontSize="3xl">
          With love,
        </Heading>
        <Center>
          <Image marginTop="16px" src={SPH_LOGO_BLACK} height="60px" />
        </Center>
      </Box>
      <Box bgColor="bgAlternative">
        <Wave
          isWhiteColor
          style={{ backgroundColor: 'transparent', transform: 'translateY(-4px)' }}
        />
        <Box padding="16px 32px">
          <Center>
            <Link href={URL_IG_INVITATO} target="_blank">
              <Image src={Invitato} maxWidth="120px" />
            </Link>
          </Center>
          <Text color="secondaryColorText" fontSize="xs" textAlign="center">
            Created with Love by Invitato
          </Text>
          <Box>
            {/* Collaboration Vendor */}
            {ENABLE_COLLABORATION && (
              <Box margin="-4px 0 8px">
                <Center>
                  <Divider
                    margin="16px 0"
                    maxWidth="30%"
                    height="1px"
                    bgColor="secondaryColorText"
                    color="secondaryColorText"
                    border="none"
                    boxShadow="none"
                    borderBottomWidth="none"
                  />
                </Center>
                <Center>
                  <Link href="https://www.instagram.com/dalangweddingorganizer/" target="_blank">
                    <Image src={LOGO_VENDOR_DALANG} maxWidth="80px" margin="-12px 0 -4px" />
                  </Link>
                </Center>
                <Center>
                  <Text color="secondaryColorText" align="center" fontSize="xs">
                    In Collaboration with Dalang
                  </Text>
                </Center>
              </Box>
            )}
            {/* Copyright */}
            <Center marginTop={ENABLE_COLLABORATION ? '6px' : '12px'}>
              <Text textAlign="center" color="secondaryColorText" fontSize="xs">
                {`© ${new Date().getFullYear()} ${THE_BRIDE}. All Rights Reserved`}
              </Text>
            </Center>
            <Center>
              <Link
                textAlign="center"
                href={SOUND_URL}
                color="secondaryColorText"
                fontSize="xs"
                isExternal
              >
                {`Song by ${SOUND_BY}`}
              </Link>
            </Center>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

CopyRightSection.propTypes = {
  fontSize: string,
  withFlatIcon: bool,
  withSong: bool,
};

CopyRightSection.defaultProps = {
  fontSize: 'sm',
  withFlatIcon: true,
  withSong: true,
};

export default React.memo(CopyRightSection);
